module.exports = {
	"pathContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/contributors.json
// module id = 451
// module chunks = 233136724938746